import React from "react";
import { Avatar } from "../../types/types";
import { TCText } from "../TCText/TCText";
import { getInitials } from "../../utils/utils";

type props = {
  avatar: Avatar;
  size?: number;
  style?: React.CSSProperties;
  nameStyle?: React.CSSProperties;
};

export const UserAvatar: React.FC<props> = ({
  avatar,
  size,
  style,
  nameStyle,
}) => {
  return avatar.image ? (
    <img
      src={avatar.image}
      alt=""
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        objectFit: "cover", // Ensures the image covers the area
        ...style,
      }}
    />
  ) : (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        backgroundColor: "black",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        ...style,
      }}>
      <TCText
        style={{
          textAlign: "center",
          color: "white",
          fontWeight: 500,
          paddingBottom: 2,
          ...nameStyle,
        }}
        value={getInitials(avatar?.name ?? "Test User")}
      />
    </div>
  );
};
